// test1754
(1754 && 0);
